export enum FiChecklist2ImportWarningType {
    InvalidComplianceThreshold = 0,
    InvalidScoringValue = 1,
    InvalidColumnHeader = 2,
    InvalidSheetName = 3,
}
